import type { AttemptReveal } from '@proref/types';
import type { CreateAttemptInput } from '@proref/schemas';
import { api, unwrap, type Envelope } from '../lib/api';

// Record the referee's answer and get the reveal (correct call + commentary + the answer
// distribution). Every submit is a real attempt — repeats are allowed and recorded; the
// server decides which one scores. user_id comes from the JWT, never the body.
export async function submitAttempt(input: CreateAttemptInput): Promise<AttemptReveal> {
  const res = await api.post<Envelope<AttemptReveal>>('/attempts', input);
  return unwrap(res.data);
}

// Re-fetch the reveal for a clip the referee already answered (no new attempt). The API
// 403s if they haven't answered yet, so only call this when the clip's viewer state says
// has_answered — the page uses it to restore the reveal + graph when re-opening a clip.
export async function getReveal(clipId: string): Promise<AttemptReveal> {
  const res = await api.get<Envelope<AttemptReveal>>(`/clips/${clipId}/reveal`);
  return unwrap(res.data);
}
